import React from "react";
import { InventoryItem } from "../types";

interface InventoryGridProps {
  inventory: InventoryItem[];
}

const InventoryGrid: React.FC<InventoryGridProps> = ({ inventory }) => {
  const getRarityColor = (rarity: string) => {
    switch (rarity) {
      case "common":
        return "#9ca3af";
      case "rare":
        return "#3b82f6";
      case "epic":
        return "#8b5cf6";
      case "legendary":
        return "#f59e0b";
      default:
        return "#9ca3af";
    }
  };

  const getRarityBackground = (rarity: string) => {
    switch (rarity) {
      case "common":
        return "rgba(156, 163, 175, 0.1)";
      case "rare":
        return "rgba(59, 130, 246, 0.1)";
      case "epic":
        return "rgba(139, 92, 246, 0.1)";
      case "legendary":
        return "rgba(245, 158, 11, 0.1)";
      default:
        return "rgba(156, 163, 175, 0.1)";
    }
  };

  // Create a grid of 20 slots (4x5)
  const gridSlots = Array.from({ length: 20 }, (_, index) => {
    const item = inventory.find((_, i) => i === index);
    return item || null;
  });

  return (
    <div className="inventory-grid">
      <h3>Inventory</h3>
      <div className="inventory-slots">
        {gridSlots.map((item, index) => (
          <div key={index} className="inventory-slot">
            {item ? (
              <div
                className="inventory-item"
                style={{
                  borderColor: getRarityColor(item.rarity),
                  backgroundColor: getRarityBackground(item.rarity),
                }}
                title={`${item.name} (${item.rarity})\n${item.description}\nQuantity: ${item.quantity}`}
              >
                <div className="item-image">
                  <img
                    src={item.image_url}
                    alt={item.name}
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      const fallback = e.currentTarget
                        .nextElementSibling as HTMLElement | null;
                      if (fallback && "style" in fallback) {
                        fallback.style.display = "block";
                      }
                    }}
                  />
                  <div className="item-fallback" style={{ display: "none" }}>
                    {item.name.charAt(0).toUpperCase()}
                  </div>
                </div>
                <div className="item-quantity">{item.quantity}</div>
                <div
                  className="item-rarity-tag"
                  style={{
                    backgroundColor: getRarityColor(item.rarity),
                    color: "white",
                  }}
                >
                  {item.rarity.toUpperCase()}
                </div>
              </div>
            ) : (
              <div className="empty-slot"></div>
            )}
          </div>
        ))}
      </div>

      <div className="inventory-stats">
        <p>Total Items: {inventory.length}</p>
        <p>
          Total Quantity:{" "}
          {inventory.reduce((sum, item) => sum + item.quantity, 0)}
        </p>
      </div>
    </div>
  );
};

export default InventoryGrid;
